var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHepaOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HEPA_ON",
    "data-name": "HEPA ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M5.15,42.71h38.7a3.862,3.862,0,0,0,3.86-3.86V5.16A3.862,3.862,0,0,0,43.85,1.3H5.15A3.862,3.862,0,0,0,1.29,5.16V38.85A3.862,3.862,0,0,0,5.15,42.71Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M43.87,44H5.13A5.145,5.145,0,0,1,0,38.85V5.15A5.145,5.145,0,0,1,5.13,0H43.87A5.145,5.145,0,0,1,49,5.15V38.86A5.143,5.143,0,0,1,43.87,44ZM5.13,2.59A2.556,2.556,0,0,0,2.58,5.15V38.86a2.556,2.556,0,0,0,2.55,2.56H43.87a2.556,2.556,0,0,0,2.55-2.56V5.15a2.556,2.556,0,0,0-2.55-2.56H5.13Z",
    fill: "#b6d3ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M6.78,15.55v4.87h5.15V15.55h2.22V27.72H11.93V22.36H6.78v5.36H4.56V15.55Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M23.5,22.32H18.91v3.57h5.13v1.82H16.69V15.55h7.08v1.82H18.91v3.14H23.5Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M25.99,15.72a19.861,19.861,0,0,1,3.4-.25,5.5,5.5,0,0,1,3.59.99,3.445,3.445,0,0,1,1.19,2.69,3.662,3.662,0,0,1-1.05,2.76,5.4,5.4,0,0,1-3.85,1.3,6.739,6.739,0,0,1-1.08-.07v4.58h-2.2v-12Zm2.2,5.66a4.572,4.572,0,0,0,1.08.09c1.66,0,2.67-.81,2.67-2.24,0-1.35-.94-2.08-2.48-2.08a5.7,5.7,0,0,0-1.28.11v4.12Z",
    fill: "#b6d3ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M37.24,24.27l-1.05,3.45H33.9l3.9-12.17h2.84l3.95,12.17H42.2l-1.1-3.45Zm3.48-1.68-.96-3c-.23-.74-.43-1.57-.61-2.27h-.04c-.18.7-.36,1.55-.58,2.27l-.94,3Z",
    fill: "#b6d3ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHepaOn);
export default __webpack_public_path__ + "static/media/hepa_on.46c66d400e76f53cf7f6f5bfc0731aae.svg";
export { ForwardRef as ReactComponent };